import { render, staticRenderFns } from "./SameRegionRequests.vue?vue&type=template&id=cda1e66c"
import script from "./SameRegionRequests.vue?vue&type=script&lang=js"
export * from "./SameRegionRequests.vue?vue&type=script&lang=js"
import style0 from "./SameRegionRequests.vue?vue&type=style&index=0&id=cda1e66c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports